module.exports = __webpack_public_path__ + "media/images/bg_access_mv_pc-38c9c24061b8bef9fbf1e74e6f7c8781.jpg";